export const isNotNil = <T>(item: T): item is NonNullable<T> => item !== null && item !== undefined;

export const getAbsoluteUrl = (url: string): string => {
  if (typeof document === 'undefined') {
    return url;
  }
  return new URL(url, document.baseURI).href;
};

export type NameListArray = {
  [key: string]: string;
};

interface IChildObject<U> {
  value?: U;
}

export function nameListToArray<T extends IChildObject<U>, U>(nameListArray: T): NameListArray[] {
  const parsedPopularSearches = Object.values(nameListArray)
    .flat()
    .map((entry: T) => entry.value)
    .map((value) => new URLSearchParams(value as string));
  const result: NameListArray[] = [];

  parsedPopularSearches.forEach((param) => {
    const entriesIterator = param.entries();
    const entriesArray: NameListArray = {};

    for (const pair of entriesIterator) {
      entriesArray[pair[0]] = pair[1];
    }
    result.push(entriesArray);
  });

  return result;
}
